// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VM2v","content":"styles_content__3XX3o"};